import { KeyWordLandingPage } from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    keywordLandingPage: KeyWordLandingPage;
  };
};

export default ({ data }: Props, { market, t }: MetaDataContext) => {
  if (!data || !data.keywordLandingPage) {
    return {};
  }

  const canonical = market.domain + data.keywordLandingPage.url;
  const noIndex = !data.keywordLandingPage.inSitemap;
  const breadcrumb = data.keywordLandingPage.parentCategory?.path;
  const newLayoutDescription =
    data.keywordLandingPage.newSearch &&
    data.keywordLandingPage.newSearch.results &&
    data.keywordLandingPage.newSearch.results.categories
      ? data.keywordLandingPage.newSearch.results.categories.nodes
          .map(category => category?.name)
          .join(' ')
      : '';
  return {
    title: t('meta', 'keyword-search-page.title', {
      keyword:
        data.keywordLandingPage.title[0].toUpperCase() +
        data.keywordLandingPage.title.slice(1),
    }),
    description:
      data.keywordLandingPage?.categories?.length > 0 ||
      (data.keywordLandingPage.newSearch?.results?.categories &&
        data.keywordLandingPage?.newSearch?.results?.categories?.nodes?.length >
          0)
        ? t('meta', 'keyword-search-page.description', {
            keyword:
              data.keywordLandingPage.title[0].toUpperCase() +
              data.keywordLandingPage.title.slice(1),
            categories: data.keywordLandingPage?.categories
              ? data.keywordLandingPage.categories
                  ?.map(({ name }) => name)
                  .join(' ')
              : newLayoutDescription,
          })
        : t('meta', 'keyword-search-page.description-offers-only', {
            keyword:
              data.keywordLandingPage.title[0].toUpperCase() +
              data.keywordLandingPage.title.slice(1),
          }),
    canonical,
    noIndex,
    breadcrumb,
  };
};
